<mat-chip-listbox 
id="chipListid"
aria-label="aria-label"
[multiple]="multiple"
[selectable]="selectable">
@for (chip of chips; track chip.label) {
    <mat-chip-option
    [selected]="chip.selected"
    [selectable]="chip.selectable"
    [disabled]="chip.disabled"
    (click)="toggleChipClick(chip)"
    >
    <span class="mat-chip-label">{{chip.label}}</span></mat-chip-option>
}
</mat-chip-listbox>